export function sanitizeSkillDescription(input: string): string {
  if (!input) return ''

  let text = `${input}`

  // Replace common templated duration phrases with human-friendly text.
  // Examples in current data: "{effect time}", "for {effect time} sec.", etc.
  text = text.replace(
    /for a duration of\s*\{[^}]+\}\s*(seconds?|secs?|sec)\.?\b/gi,
    'for a short duration',
  )
  text = text.replace(
    /lasts for\s*\{[^}]+\}\s*(seconds?|secs?|sec)\.?\b/gi,
    'lasts for a short duration',
  )
  text = text.replace(
    /for\s*\{[^}]+\}\s*(seconds?|secs?|sec)\.?\b/gi,
    'for a short duration',
  )
  text = text.replace(
    /over\s*\{[^}]+\}\s*(seconds?|secs?|sec)\.?\b/gi,
    'over a short duration',
  )
  text = text.replace(/over\s*\{[^}]+\}/gi, 'over time')
  text = text.replace(/for\s*\{[^}]+\}/gi, 'for a short duration')

  // Remove any remaining template tokens.
  text = text.replace(/\{[^}]+\}/g, '')

  // Normalize whitespace and punctuation.
  text = text.replace(/\u00a0/g, ' ')
  text = text.replace(/[ \t]+\n/g, '\n')
  text = text.replace(/\n[ \t]+/g, '\n')
  text = text.replace(/\n{3,}/g, '\n\n')
  text = text.replace(/[ \t]{2,}/g, ' ')
  text = text.replace(/\s+([,.;:!?])/g, '$1')

  return text.trim()
}

